import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { AppContainer } from '@nutastic/nutastic-react-app';
import HomePage from '../pages/HomePage';
import Footer from '../Footer';
import Header from '../Header';

const App = () => {
    const renderPageRoute = () => {
        return <Switch>
            <Route path='/' exact={true} component={HomePage}/>
            <Route path='/home' component={HomePage}/>
        </Switch>;
    };

    return <AppContainer>
        <Header />
        { renderPageRoute() }
        <Footer />
    </AppContainer>;
};

export default App;
